import React from "react";
import { Link } from "react-router-dom";
import HeaderNav from "@/components/HeaderNav";
import GigsTab from "@/pages/GigsTab";
import { Sparkles, ArrowRight } from "lucide-react";

export default function GigsPublic() {
  return (
    <div className="min-h-screen">
      <HeaderNav/>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-8 lg:py-12">
        <div className="mb-8">
          <div className="caption">Public feed · no signup required</div>
          <h1 className="font-display text-4xl sm:text-6xl font-black leading-tight mt-2">
            Live jobs & side hustle gigs.
          </h1>
          <p className="text-lg text-[var(--stone)] mt-3 max-w-2xl">
            Every 15 minutes we pull real, paying opportunities from RemoteOK, Arbeitnow and
            WeWorkRemotely. Filter by category, search by tech. Apply directly.
          </p>
        </div>

        <div className="card-warm p-5 mb-8 flex flex-wrap items-center justify-between gap-4"
             style={{background:"var(--forest)", color:"var(--alabaster)"}}>
          <div>
            <div className="caption" style={{color:"#D96B27"}}><Sparkles size={12} className="inline mr-1"/> Get personalized matches</div>
            <div className="font-display text-xl font-bold mt-1">
              Take the 60-sec quiz. Get AI-ranked side hustles + blueprints for your skills.
            </div>
          </div>
          <Link to="/" className="btn-copper" data-testid="public-gigs-cta-btn">
            Start free quiz <ArrowRight size={16}/>
          </Link>
        </div>

        <GigsTab/>
      </div>
    </div>
  );
}
